import React from 'react'
import styled, { useTheme } from 'styled-components'
import { Icon } from '@centivo/react-components'

import { CATEGORY } from 'src/refactor/helpers/constants'
import { useMediaContext } from 'src/context/responsive'
import ArrowDownLeftDesktopImage from 'src/assets/Images/arrow-down-left-desktop.svg'
import SearchBarAside from './SearchBarAside'

const SearchBarMessageDesktopContainer = styled.div`
  display: flex;
  flex: 1;
  margin-top: 40px;
`

const SearchBarMessageDesktopSideColumnContainer = styled.div`
  display: flex;
  flex: 1;
`

const SearchBarMessageArrowImage = styled.img`
  margin-top: -130px;
`

const SearchBarMessageMobileContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: 20px;
`

interface Props {
  disableTabButtons: boolean
  category: CATEGORY
}

const SearchBarDisclaimerContent: React.FC<Props> = ({
  disableTabButtons,
  category,
}) => {
  const { isDesktopView } = useMediaContext()
  const theme = useTheme()

  if (!disableTabButtons && category && isDesktopView) {
    return (
      <SearchBarMessageDesktopContainer>
        <SearchBarMessageDesktopSideColumnContainer />
        <SearchBarAside />
        <SearchBarMessageDesktopSideColumnContainer>
          <SearchBarMessageArrowImage
            src={ArrowDownLeftDesktopImage}
            alt="Search button arrow pointing to disclaimer text"
            width="128"
            height="145"
          />
        </SearchBarMessageDesktopSideColumnContainer>
      </SearchBarMessageDesktopContainer>
    )
  }

  if (!disableTabButtons && category && !isDesktopView) {
    return (
      <SearchBarMessageMobileContainer>
        <div
          style={{ display: 'flex', marginLeft: '26px', marginBottom: '8px' }}
        >
          <Icon
            aria-hidden
            icon="slice-curly-arrow-down"
            size={40}
            color={theme.palette.brand.orange}
          />
        </div>
        <SearchBarAside />
      </SearchBarMessageMobileContainer>
    )
  }

  return null
}

export default SearchBarDisclaimerContent
